import DownloadModal from './download-modal';
export default DownloadModal;
